export default __webpack_public_path__ + "static/media/61t.b4765ca6.jpg";